import React, { useState } from "react";
import "./SerachCategories.css";
import { API_BASE_URL } from "../../utils";
import { Link } from "react-router-dom";
import BlogImg from "../../Assets/blog.png"




const SerachCategories = ({ clubs = [], events = [], packages = [],  }) => {
    const format = (str) =>
        str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "";

    const generateClubUrl = (clubName, cityName, areaName) =>
        `/${format(clubName)}-${format(cityName)}-${format(areaName)}`;

    const generatePackageUrl = (clubName, cityName, areaName, title) =>
        `/party-package/${format(clubName)}-${format(cityName)}-${format(
            areaName
        )}/${format(title)}`;

    const generateEventUrl = (clubName, cityName, areaName, title) =>
        `/event/${format(clubName)}-${format(cityName)}-${format(
            areaName
        )}/${format(title)}`;

    // ✅ Transform API data into category structure
    const categoriesData = {
        Events: {
            image: "https://images.unsplash.com/photo-1583906326458-5eb89bf0f911?q=80&w=687&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
            items: events.map((event) => ({
                name: event.name,
                image: `${API_BASE_URL}/master/assets/uploads/${event.image}`,
                url: generateEventUrl(
                    event.clubName,
                    event.cityName,
                    event.areaName,
                    event.name
                ),
            })),
        },
        Venue: {
            image: "https://images.unsplash.com/photo-1675247488725-22d1b78e75db?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8dmVudWVzfGVufDB8fDB8fHww",
            items: clubs.map((club) => ({
                name: club.name,
                image: `${API_BASE_URL}/master/assets/uploads/${club.profile_pic}`,
                url: generateClubUrl(club.name, club.cityName, club.areaName),
            })),
        },
        Packages: {
            image: "https://partywitty.com/master/assets/uploads/1708861625_380e2e555443773889eb.jpg",
            items: packages.map((pkg) => ({
                name: pkg.title,
                image: `${API_BASE_URL}/master/assets/uploads/${pkg.packageThumbnail}`,
                url: generatePackageUrl(
                    pkg.clubName,
                    pkg.cityName,
                    pkg.areaName,
                    pkg.title
                ),
            })),
        },
    };

    // ✅ Default active category = first key
    const [activeCategory, setActiveCategory] = useState(
        Object.keys(categoriesData)[0]
    );

    return (
        <div>
            <div className="categories-wrapper">
                <h3 className="categories-title">Categories for you</h3>

                {/* Top category buttons */}
                <div className="categories-top">
                    {Object.keys(categoriesData).map((cat) => (
                        <div
                            key={cat}
                            className={`category-card ${activeCategory === cat ? "active" : ""}`}
                            onClick={() => setActiveCategory(cat)}
                        >
                            <div className="category-img-wrapper ">
                                <img className="m-hide" src={categoriesData[cat].image} alt={cat} />
                                <span className={`category-count + ${activeCategory === cat ? " active" : ""}`}>
                                    {categoriesData[cat].items.length}
                                </span>
                            </div>
                            <p>{cat}</p>
                        </div>
                    ))}
                </div>

                {/* Items below */}
                {categoriesData[activeCategory]?.items.length === 0 ? (
                    <p className="no-items-found">No items found</p>
                ) : (
                    <div className="categories-items">
                        {categoriesData[activeCategory]?.items.map((item, index) => (
                            <Link to={item.url}
                                key={index}
                                className="item-card"
                            // onClick={() => (window.location.href = item.url)}
                            >
                                <img src={item.image} alt={item.name} />
                                <p>
                                    {item.name.length > 13 ? item.name.slice(0, 13) + "..." : item.name}
                                </p>

                            </Link>
                        ))}
                    </div>
                )}
            </div>
            <div className="categories-wrapper">
           
                <div className="d-flex justify-content-between">
                    <h3 class="categories-title">Categories for you</h3>
                    <a href="" className="d-flex gap-2 view-all">
                        View all 
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8" fill="none">
                            <path d="M10.3417 3.16667H0.333344V4.83333H10.3417V7.33333L13.6667 4L10.3417 0.666668V3.16667Z" fill="#151515"/>
                        </svg>
                    </a>
                </div>

                <div className="blog-wrapper d-flex d-flex flex-column gap-2">
                    <div className="blog-section">
                        <div className="img">
                            <img src={BlogImg} alt="blog" />
                        </div>
                        <div className="blog-content">
                            <div className="d-flex gap-2 justify-content-between">
                                <h5>Title</h5>
                                <div className="d-flex gap-2 align-items-center">
                                    <span>Jan 4, 2022</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 2 3" fill="none">
                                        <circle cx="1" cy="1.5" r="1" fill="#828282"/>
                                    </svg>
                                    <span>3344 views</span>
                                </div>
                            </div>
                            <p>Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</p>
                        </div>
                    </div>
                    <div className="blog-section">
                        <div className="img">
                            <img src={BlogImg} alt="blog" />
                        </div>
                        <div className="blog-content">
                            <div className="d-flex gap-2 justify-content-between">
                                <h5>Title</h5>
                                <div className="d-flex gap-2 align-items-center">
                                    <span>Jan 4, 2022</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 2 3" fill="none">
                                        <circle cx="1" cy="1.5" r="1" fill="#828282"/>
                                    </svg>
                                    <span>3344 views</span>
                                </div>
                            </div>
                            <p>Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</p>
                        </div>
                    </div>
                    <div className="blog-section">
                        <div className="img">
                            <img src={BlogImg} alt="blog" />
                        </div>
                        <div className="blog-content">
                            <div className="d-flex gap-2 justify-content-between">
                                <h5>Title</h5>
                                <div className="d-flex gap-2 align-items-center">
                                    <span>Jan 4, 2022</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 2 3" fill="none">
                                        <circle cx="1" cy="1.5" r="1" fill="#828282"/>
                                    </svg>
                                    <span>3344 views</span>
                                </div>
                            </div>
                            <p>Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</p>
                        </div>
                    </div>
                    <div className="blog-section">
                        <div className="img">
                            <img src={BlogImg} alt="blog" />
                        </div>
                        <div className="blog-content">
                            <div className="d-flex gap-2 justify-content-between">
                                <h5>Title</h5>
                                <div className="d-flex gap-2 align-items-center">
                                    <span>Jan 4, 2022</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="5" height="5" viewBox="0 0 2 3" fill="none">
                                        <circle cx="1" cy="1.5" r="1" fill="#828282"/>
                                    </svg>
                                    <span>3344 views</span>
                                </div>
                            </div>
                            <p>Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</p>
                        </div>
                    </div>
                </div>


            </div>
        </div>

      
    );
};

export default SerachCategories;
